import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const componentName = "SalesSummary";

const Header = (props) => (
    <div className="searchBarContainer">
        <div className="row row_margin_none">
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    fullWidth={true}
                    label={LOOKUP.report.common.branch}
                    floatingLabelText={LOOKUP.report.common.branch}
                    hintText={LOOKUP.report.common.branch}
                    defaultValue={props.loggedBranch.toString()}
                    options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.selectedDate.name}
                    floatingLabelText={LOOKUP.report.common.selectedDate.label + "*"}
                    hintText={LOOKUP.report.common.selectedDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.filter}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                <p className="blue-text"><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders will be counted in this report.</i></strong></p>
            </div>
        </div>
    </div>
);

export default Header;
